import './confirmProSignup.scss';

export const ConfirmProSignup = () => {
  return (
    <div className="confirm-pro-signup">
      
    </div>
  )
}